import firebase, { database } from "../firebase";
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";
import { API_URL } from "../Constatnts";

export function setStores(stores) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_STORES, stores });
  };
}

export function saveBarcodeSetting(barcodeSetting, key)  {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
   
      const response = await axios.put(
        `${constants.API_URL}/setup/stores/barcodesettings/${key}`,
        barcodeSetting,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true
      }
      else{
        return false
      }
    
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getBarcodeSettingDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/stores/barcodesettings/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function addNewStore(store)  {
  return async (dispatch, getState) => {
    try {
      var startDate = new Date().toISOString().split("T")[0];

    let date = new Date();
    let expiryDays = 15;

    if (
      getState().config.WhiteLabel.Code === "PINCODE" &&
      getState().registration
    ) {
      expiryDays = 182;
    }

    date.setDate(date.getDate() + expiryDays);
    var endDate = new Date(date).toISOString().split("T")[0];
    store.NoOfEmployeesAllowed = 1;
    store.NoOfTransactionalSMS = 0;
    store.NoOfCashRegistersAllowed = 1;
    store.NoOfUsersAllowed = 1;
    store.StartDate = startDate;
    store.ExpiryDate = endDate;

      const token = getState().user.uat;
   
      const response = await axios.post(
        `${constants.API_URL}/setup/stores/`,
        store,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.data.key;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}





export function getStoresList(
  from,
  size,
  option,
  searchText = '',
  searchCity = '',
  searchState = '',
  searchPostalCode = '',
  searchCountry = '',
  searchEmail = '',
  searchPhone = '',
  searchCustomField1 = '',
  searchCustomField2 = '',
  searchCustomField3 = '',
  searchCustomField4 = '',
  searchCustomField5 = '',
  searchCustomField6 = ''
) {
 return async (dispatch, getState) => {
  try {
    const token = getState().user.uat;

    let apiUrl = "/setup/searchstores";

    const params = {
      from: Number(from),
      size: Number(size),
      option: option,

      searchText: searchText,
      searchCity: searchCity,
      searchState: searchState,
      searchPostalCode: searchPostalCode,
      searchCountry: searchCountry,
      searchEmail: searchEmail,
      searchPhone: searchPhone,
      searchCustomField1: searchCustomField1,
      searchCustomField2: searchCustomField2,
      searchCustomField3: searchCustomField3,
      searchCustomField4: searchCustomField4,
      searchCustomField5: searchCustomField5,
      searchCustomField6: searchCustomField6
    };

    let queryParams = [];

    Object.keys(params).forEach((key) => {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== ''
      ) {
        queryParams.push(
          key + "=" + encodeURIComponent(params[key])
        );
      }
    });

    if (queryParams.length > 0) {
      apiUrl = apiUrl + "?" + queryParams.join("&");
    }

    const response = await axios.get(
      constants.API_URL + apiUrl,
      {
        headers: {
          Authorization: "Bearer " + token
        }
      }
    );

    if (response && response.hasOwnProperty("data")) {
      return response.data;
    }

    return null;

  } catch (error) {
    console.error("Error fetching store data:", error);

    if (
      error &&
      error.hasOwnProperty("response") &&
      error.response &&
      error.response.hasOwnProperty("data")
    ) {
      throw error.response.data;
    }

    throw error;
  }
};
}

export function getUserStores(registrationID, userID) {
  let user = { RegistrationID: registrationID };
  return async (dispatch, getState) => {
    let userStores = [];
    // let addMessage = firebase.functions().httpsCallable("getUserStoresV1");
    // return addMessage({ text: user }).then(function(result) {
    //   userStores = result.data.text;
    //   dispatch({ type: actionTypes.SET_USER_STORES, userStores });
    //   return userStores;
    // });
    //9 Mar 26
    ///user/stores

    const token = getState().user.uat;
    let response = await axios.get(API_URL + "/user/stores", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response);
    if (response && response.data && response.data.stores) {
      userStores = response.data.stores;
      dispatch({ type: actionTypes.SET_USER_STORES, userStores });
      return userStores;
    }
  };
}

function getLastLoggedInStore(registrationID) {
  let store = JSON.parse(localStorage.getItem("store"));
  // console.log('checkUserInLocalStorage', store)
  if (store && store.RegistrationID === registrationID) {
    return store;
  } else {
    return null;
  }
}

// export function deleteStore(key) {
//   return (dispatch, getState) => {
//     return database
//       .collection("Stores")
//       .doc(key)
//       .update({
//         IsDeleted: true,
//         ActionOn: firebase.firestore.FieldValue.serverTimestamp(),
//         ActionBy: getState().user.user.Name,
//         ActionByUID: getState().user.user.UID,
//         ActionByEmailID: getState().user.user.EmailID,

//         Action: constants.AUDIT_TRAIL_DELETE,
//       })
//       .then(() => {
//         return true;
//       });
//   };
// }


export function deleteStore(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/setup/stores/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return true;
      } else {
        alert(response.data.message || "Failed to delete store");
        return false;
      }

    } catch (error) {
      console.error("delete store Error:", error);
      alert("Failed to delete store");
      return false;
    }
  };
}

export function getStoreDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/stores/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.store;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function updateStore(store, key, action = "")  {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
   
      const response = await axios.put(
        `${constants.API_URL}/setup/stores/${key}`,
        store,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true;
      }
      else{
        return false;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function checkIfStoreCodeIsUnique(storeCode, storeID, registrationID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
       const response = await axios.get(
        `${constants.API_URL}/setup/stores/checkIfStoreCodeIsUnique`,
        {
          params: {
            storeCode,
            storeID,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.isUnique;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}





